import { render, staticRenderFns } from "./ElderlyInsWaitCheckin3.vue?vue&type=template&id=0322e114&scoped=true&"
import script from "./ElderlyInsWaitCheckin3.vue?vue&type=script&lang=js&"
export * from "./ElderlyInsWaitCheckin3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0322e114",
  null
  
)

export default component.exports